import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiaItem } from "./item";

export interface Props {
    items: models.GuiaEntregaZESelect[];
    onSeleccionar: (item: models.GuiaEntregaZESelect, value: boolean | null) => void;
    onMotivoChange: (item: models.GuiaEntregaZESelect, value: string) => void;
    nuevo: boolean;
}

/**Muestra el listado de las guias que se van a entregar */
export class ListGuiasEntregaMem extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <kea.Title titulo="Guias" />
                {this.props.items.map(x =>
                    <GuiaItem key={x.Guia.IdRegistro} value={x} onSeleccionar={value => this.props.onSeleccionar(x, value)} onMotivoChange={value => this.props.onMotivoChange(x, value)} nuevo={this.props.nuevo} />
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entrega/list/listmem.tsx